import { Component, HostListener, ChangeDetectionStrategy, inject } from '@angular/core';
import { Icons } from '../../../util/Icons';
import { SessionService } from '../../../services/session.service';
import { LayoutService } from '../../../../@vex/services/layout.service';
import { RealEstateReport } from '@eadsysteme/energyefficiencyclient-v1';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';
import AppendixSendingOptionsEnum = RealEstateReport.AppendixSendingOptionsEnum;

@Component({
	selector: 'vex-print-dialog',
	templateUrl: './print-dialog.component.html',
	styleUrls: ['./print-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslocoDirective,
		CdkDrag,
		MatIconButton,
		MatIcon,
		CdkDragHandle,
		MatAccordion,
		MatExpansionPanel,
		MatExpansionPanelHeader,
		MatExpansionPanelTitle,
		MatExpansionPanelDescription,
		MatRadioGroup,
		ReactiveFormsModule,
		FormsModule,
		MatRadioButton,
		MatDialogActions,
		NgClass,
		DefaultClassDirective,
		MatButton,
	],
})
export class PrintDialogComponent {
	dialogRef = inject<MatDialogRef<PrintDialogComponent>>(MatDialogRef);
	icons = inject(Icons);
	sessionService = inject(SessionService);
	layoutService = inject(LayoutService);
	printDialogData = inject(MAT_DIALOG_DATA);

	chosenTargetFormat = 'DOCUMENT';
	chosenFileFormat = 'PDF';
	chosenInfoSheetOption = 'NO';
	targetFormats: string[] = [];
	fileFormats: string[] = ['ZIP', 'PDF'];
	infoSheetOption: string[] = Object.values(AppendixSendingOptionsEnum);
	isPrintProtocol = true;
	isMobile = false;

	constructor() {
		const layoutService = this.layoutService;
		const printDialogData = this.printDialogData;

		this.isMobile = layoutService.isMobile();
		if (printDialogData.showOutboxOption) {
			this.targetFormats = ['DOCUMENT', 'OUTBOX'];
		} else {
			this.targetFormats = ['DOCUMENT'];
		}
	}

	close(saved: boolean): void {
		if (saved) {
			const data = {
				targetFormat: this.chosenTargetFormat,
				printProtocol: this.isPrintProtocol,
				fileFormat: this.chosenTargetFormat === 'DOCUMENT' ? this.chosenFileFormat : undefined,
				sheetOption: this.chosenTargetFormat === 'OUTBOX' ? this.chosenInfoSheetOption : undefined,
			};
			this.dialogRef.close({ saved, data });
		} else {
			this.dialogRef.close({ saved });
		}
	}

	@HostListener('document:keydown.escape', ['$event'])
	onEscapeKey(event: Event): void {
		event.preventDefault();
		this.close(false);
	}
}
